import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import FormContainer from '../layout/form-container';

const LoginWisemapping = (): React.ReactElement => {
  const location = useLocation();
  const cookies = new Cookies();
  const expMs = 100000 * 10080;

  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token_value');
    const retrunUrl = queryParams.get('redirect');

    if (token) {
      cookies.set('jwt-auth-token', token, { path: '/', maxAge: expMs });
      window.location.href = retrunUrl || 'https://thinkmapping.com';
    }
  }, [location.search]);

  return (
    <div>
     <FormContainer>
        <h1>Bienvenue</h1>
        <img src="thinkmapping-logo.png" />
        <img src="loader.gif" />
      </FormContainer>
    </div>
  );
};

export default LoginWisemapping;